import { IConfirmableInjectedAction } from '../../../../interfaces';
import {map} from "rxjs/operators";
import {get, isEmpty} from "lodash";

export class InjectedOrganizationAccessAction implements IConfirmableInjectedAction {
  private rowData: any;
  performActionAfterConfirm = (bindObj, action) => {
    const orgData = [];

    let orgIdsArr = '';
    action.rowData.context.forEach((val) => {
      orgIdsArr += `${val.reference}` + ',';
    });
    orgIdsArr = orgIdsArr.substring(0, orgIdsArr.length-1);
    let queryString = `organization?_id=${orgIdsArr}&_sort:asc=name|transform=concatinatedDisplayName:display,id:code`;
    bindObj.worklist.searchService.query(queryString, "", {}, false, {}, true).pipe(map((res: any) => {
      if (!isEmpty(res)) {
        res.forEach(item => {
          orgData.push({ 'id': item.id, 'name': item.name});
        });
      }
    })).subscribe();

    const navData = {
      managingOrganization: orgData,
      id: action.rowData.id
    };
    action.formHandlerService.popupDynamicFormModal(
      'Organization Access',
      'ACCESS-ORGANIZATION-REPORT',
      {'OrganizationAccess' : navData} ,
      'Save',
      'Cancel',
      { },
      'ORGACCESS_POPUP_MODAL_CHANNEL'
    );
  }
}
